import { captureException } from '@sentry/react'
import type { FirebaseRepository } from '@breakoutlearning/firebase-repository/models/FirebaseRepository'

export function captureVitePreloadError(event: VitePreloadErrorEvent) {
  captureException(event.payload, {
    contexts: {
      vite_preload_error: {
        event_type: event.type,
        event_time_stamp: event.timeStamp,
        event_bubbles: event.bubbles,
        event_cancelable: event.cancelable,
        event_composed: event.composed,
        event_default_prevented: event.defaultPrevented,
        event_is_trusted: event.isTrusted,
        error_name: event.payload.name,
        ...getOwnProperties(event.payload),
      },
      page: {
        url: `${window.location.origin}${window.location.pathname}`,
        visibility_state: document.visibilityState,
      },
    },
  })
}

export function logVitePreloadError(
  event: VitePreloadErrorEvent,
  repository: Pick<FirebaseRepository, 'logEvent'>
) {
  repository.logEvent('vite_preload_error', {
    error_name: event.payload.name,
    error_message: event.payload.message,
    page_path: window.location.pathname,
    visibility_state: document.visibilityState,
  })
}

function getOwnProperties(value: object) {
  const properties: Record<string, unknown> = {}

  for (const propertyName of Object.getOwnPropertyNames(value)) {
    properties[propertyName] = Object.getOwnPropertyDescriptor(
      value,
      propertyName
    )?.value
  }

  return properties
}
